import { render, staticRenderFns } from "./on-off.vue?vue&type=template&id=6fc3d06c&scoped=true&"
import script from "./on-off.js?vue&type=script&lang=js&"
export * from "./on-off.js?vue&type=script&lang=js&"
import style0 from "./on-off.css?vue&type=style&index=0&id=6fc3d06c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc3d06c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
